import { useCallback } from 'react';
import { ROW_TYPES } from './tableConfig';
import { COLUMNS } from './columns';
import { DataDeletionListItem } from './types';
import { CellWithBorderClassNames } from 'shared/styles';
import { TeamPendingDeletion } from 'TeamModule/services/GetTeamsPendingDeletionApi';

const cellClassNameByColumns: Record<string, CellWithBorderClassNames[]> = {
  [COLUMNS.CHECKBOX]: ['sticky', 'zindex3'],
};

const headerListItem: DataDeletionListItem = {
  id: ROW_TYPES.HEADER,
  rowType: ROW_TYPES.HEADER,
  isStickyHeader: true,
  cellClassNameByColumns,
};

export const useDataDeletionListItemBuilder = () => {
  const builder = useCallback(({ teams }: { teams: TeamPendingDeletion[] }) => {
    const dataRows: DataDeletionListItem[] = teams.map((team) => ({
      id: team.id,
      rowType: ROW_TYPES.DATA,
      team,
      cellClassNameByColumns,
    }));

    return [headerListItem, ...dataRows];
  }, []);

  return builder;
};
